export default "__VITE_ASSET__CcmI7I8K__"